import { BookingOnboardingDto } from '@shared/core/booking-onboarding'
import { FC, useMemo } from 'react'
import { Icon, Typography } from 'src/modules/core/components'
import { BookingDismissBox } from './booking-dismiss-box'
import classes from './settings-booking-page-tab.module.scss'

interface BookingOnboardingIncompleteProps {
  onboardingData: BookingOnboardingDto
  onShowAvailabilitySettings: () => void
  onShowAppointmentTypesSettings: () => void
}

export const BookingOnboardingIncomplete: FC<BookingOnboardingIncompleteProps> = ({
  onboardingData,
  onShowAvailabilitySettings,
  onShowAppointmentTypesSettings,
}) => {
  const completedSteps = useMemo(() => {
    let count = 0
    if (onboardingData?.availability_set) count++
    if (onboardingData?.appointment_type_created) count++
    return count
  }, [onboardingData])

  const steps = [
    {
      id: 'availability',
      title: 'Set Your Availability',
      description: 'Configure when customers can book with you',
      completed: onboardingData?.availability_set === true,
      onClick: onShowAvailabilitySettings,
    },
    {
      id: 'appointment-types',
      title: 'Create Appointment Types',
      description: 'Define the types of appointments you offer',
      completed: onboardingData?.appointment_type_created === true,
      onClick: onShowAppointmentTypesSettings,
    },
  ]

  return (
    <div className={classes.onboardingSection}>
      <Typography variant="h5" className={classes.title}>
        Getting Started
      </Typography>
      <Typography variant="body" className={classes.subtitle} style={{ marginBottom: 0 }}>
        Complete these steps to set up your booking system.
      </Typography>
      <Typography variant="body" className={classes.subtitle}>
        Share a link and let clients schedule without endless emails.
      </Typography>
      <Typography variant="body" className={classes.progress}>
        {completedSteps} of {steps.length} steps completed
      </Typography>

      <div className={classes.stepsList}>
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={classes.stepItem}
            onClick={step.onClick}
            style={step.onClick ? { cursor: 'pointer' } : undefined}
          >
            <div className={classes.stepHeader}>
              <div className={classes.stepIcon}>
                {step.completed ? (
                  <Icon name="successCheckmark" className={classes.checkIcon} />
                ) : (
                  <div className={classes.stepNumber}>{index + 1}</div>
                )}
              </div>
              <div className={classes.stepContent}>
                <Typography variant="body" className={classes.stepTitle}>
                  {step.title}
                </Typography>
                <Typography variant="body" className={classes.stepDescription}>
                  {step.description}
                </Typography>
              </div>
            </div>
          </div>
        ))}
      </div>

      <BookingDismissBox />
    </div>
  )
}
